import { render, staticRenderFns } from "./NavbarWalletSessionConnectedDropdown.vue?vue&type=template&id=0cf289be"
import script from "./NavbarWalletSessionConnectedDropdown.vue?vue&type=script&lang=ts"
export * from "./NavbarWalletSessionConnectedDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports